function Icon(props: { isHovered: boolean }) {
  return (
    <svg viewBox="0 0 32 32" width="32" height="32">
      <g>
        <title>Trace Icons_1-3</title>
        <path d="M15.83,8.57a4.29,4.29,0,1,0,4.29,4.29A4.3,4.3,0,0,0,15.83,8.57Zm0,7.28a3,3,0,1,1,3-3A3,3,0,0,1,15.83,15.85Z"></path>
        <path d="M16,3.73A12.27,12.27,0,1,0,28.28,16,12.29,12.29,0,0,0,16,3.73ZM9.86,25.09v-.93a4.62,4.62,0,0,1,4.62-4.62h2.71a4.63,4.63,0,0,1,4.62,4.62V25.3a10.9,10.9,0,0,1-11.95-.21Zm13.25-.74v-.19a5.93,5.93,0,0,0-5.92-5.92H14.48a5.91,5.91,0,0,0-5.91,5.81,11,11,0,1,1,14.54.3Z"></path>
      </g>
    </svg>
  );
}

export default Icon;
